import React, { useState } from 'react';
import { IconButton, Button, CircularProgress } from '@mui/material';
// import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined';
import { FileUpload } from '../../utility/fetches';
import notification from '../../utility/notification';
import { FaCamera } from 'react-icons/fa';

const UploadButton = ({
  onUploadSuccess,
  onUploadError,
  acceptedFiles = "image/jpeg,image/png,image/gif,image/tiff,image/bmp,video/mp4,video/mkv,video/avi",
  buttonText = "Upload File",
  buttonProps = {},
  patientRef,
  disabled = false,
  type = "default", // New prop to determine button type
}) => {
  const [uploading, setUploading] = useState(false);

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Check file size
    const isImage = file.type.startsWith('image/');
    const isVideo = file.type.startsWith('video/');
    const maxSize = isImage ? 3 * 1024 * 1024 : isVideo ? 10 * 1024 * 1024 : 0;

    if (file.size > maxSize) {
      notification({
        type: 'error',
        message: `File size exceeds the limit of ${isImage ? '3MB' : '10MB'}`
      });
      return;
    }

    setUploading(true);
    const formData = new FormData();
    formData.append('files', file);

    try {
      await FileUpload(formData, (response) => {
        if (response?.code === 1) {
          notification({
            type: 'success',
            message: 'File uploaded successfully'
          });
          onUploadSuccess?.(response);
        } else {
          throw new Error('Upload failed');
        }
      }, patientRef);
    } catch (error) {
      notification({
        type: 'error',
        message: 'Failed to upload file'
      });
      onUploadError?.(error);
    } finally {
      setUploading(false);
    }
  };

  return (
    <>
      <input
        type="file"
        accept={acceptedFiles}
        style={{ display: 'none' }}
        onChange={handleFileChange}
        ref={patientRef}
      />
      {type === "comment" ? (
        <IconButton
          onClick={() => patientRef?.current.click()}
          disabled={disabled || uploading}
          sx={{
            backgroundColor: '#f5f5f5',
            borderRadius: '50%',
            '&:hover': {
              backgroundColor: '#e0e0e0',
            },
            ...buttonProps.sx,
          }}
        >
          {uploading ? <CircularProgress size={20} /> : <FaCamera fontSize="small" />}
        </IconButton>
      ) : (
        <Button
          component="label"
          sx={{
            backgroundColor: 'green', // Green background
            color: 'white',
            '&:hover': {
              backgroundColor: '#45a049', // Darker green on hover
            },
            ...buttonProps.sx,
          }}
          variant="contained"
          disabled={disabled || uploading}
          startIcon={uploading ? <CircularProgress size={20} /> : <FaCamera fontSize='20px' />}
          {...buttonProps}
        >
          {uploading ? 'Uploading…' : buttonText}
          <input
            type="file"
            accept={acceptedFiles}
            onChange={handleFileChange}
            style={{ display: 'none' }}
          />
        </Button>
      )}
    </>
  );
};

export default UploadButton;
